import { ChangeDetectionStrategy, Component, computed, inject, input, Signal } from '@angular/core';
import { Router, RouterLink } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { CurrentLanguageSignalService, EventsService } from '@presentationServices';
import { ButtonComponent, EventItem, LoadingComponent } from '@shared';
import { BaseScreenComponent } from '@klubovna/shared-ui';
import { PhotoCardComponent, PhotoCardData } from '../photo-card/photo-card.component';

@Component({
  selector: 'k-upcoming-events-teaser',
  imports: [ TranslateModule, ButtonComponent, RouterLink, LoadingComponent, PhotoCardComponent ],
  templateUrl: './upcoming-events-teaser.component.html',
  styleUrl: './upcoming-events-teaser.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UpcomingEventsTeaserComponent extends BaseScreenComponent {
  private eventsService: EventsService = inject(EventsService);
  private currentLanguage: CurrentLanguageSignalService = inject(CurrentLanguageSignalService);
  private readonly router: Router = inject(Router);

  currentEventIdSig = input<string>();

  languageButtonLabelSig: Signal<'en' | 'sk'> = this.currentLanguage.languageButtonLabelSig;
  loadingSig: Signal<boolean> = this.eventsService.eventsLoadingSig;
  upcomingSig: Signal<EventItem[]> = computed(() =>
    this.eventsService
      .upcomingEvents()
      .filter((e) => (!this.currentEventIdSig() ? true : e.id !== this.currentEventIdSig()))
      .slice(0, 4),
  );

  navigateToEvent(eventSlug: string): void {
    this.gtagService.trackEvent('upcoming-event', 'click');
    this.router.navigate([ '/event', eventSlug ]).then();
    if (typeof window !== 'undefined') {
      window.scrollTo({
        top: 0,
        behavior: 'smooth',
      });
    }
  }

  getCardData(event: EventItem): PhotoCardData {
    const tags = event?.tags?.map((tag) => tag.name[this.languageButtonLabelSig()]);

    return {
      imageUrl: event.thumbnailPicture,
      title: event.name[this.languageButtonLabelSig()],
      dateText: new Date(event.date),
      tags: tags,
    };
  }
}
